import React from "react";

const ScreenSelection = ({ onSelectMode, t }) => {
  return (
    <div className="screen-selection">
      <div className="screen-selection__inner container-fluid d-flex justify-content-center align-items-center">
        <div className="text-center">
          <h1 className="screen-selection-title mb-5 fw-bold text-gradient">
            {t.screen_selection_title}
          </h1>
          <div className="row justify-content-center g-4">
            <div className="col-auto">
              <div 
                className="card screen-selection-card shadow-lg border-0 h-100"
                onClick={() => onSelectMode('single')}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && onSelectMode('single')}
              >
                <div className="card-body text-center p-5">
                  <div className="screen-icon-wrapper mb-4">
                    <i className="fa-solid fa-desktop screen-icon text-primary"></i>
                  </div>
                  <h4 className="card-title fw-bold mb-3">{t.one_screen}</h4>
                  <p className="card-text text-muted">
                    Полноэкранный режим для демонстрации
                  </p>
                </div>
                <div className="card-footer border-0 bg-transparent">
                  <small className="text-muted">Рекомендуется для презентаций</small>
                </div>
              </div>
            </div>
            <div className="col-auto">
              <div 
                className="card screen-selection-card shadow-lg border-0 h-100"
                onClick={() => onSelectMode('quad')}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && onSelectMode('quad')}
              >
                <div className="card-body text-center p-5">
                  <div className="screen-icon-wrapper mb-4">
                    <i className="fa-solid fa-th-large screen-icon text-success"></i>
                  </div>
                  <h4 className="card-title fw-bold mb-3">{t.four_screens}</h4>
                  <p className="card-text text-muted">
                    Разделение на 4 области для мониторинга
                  </p>
                </div>
                <div className="card-footer border-0 bg-transparent">
                  <small className="text-muted">Идеально для больших экранов</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScreenSelection;
